<template>
    <v-container class="px-5" fluid>
        <v-row>
            <v-col align-self="start" md="7">
                <!-- <v-img class="mt-10" src="@/assets/map.jpg">
                </v-img> -->
                <video id="myVideo" autoplay muted>
                    <source src="./../assets/rbs_bot_map.mp4" type="video/mp4">
                </video>
                <h3 class="display-1 font-weight-bold text-center mt-5">GPS 25.0000° N, 89.0000° E</h3>
                <div class="d-flex align-center justify-center">
                    <v-btn class="mt-4" color="primary" large to="control-bot" target="_blank">Manage Bot</v-btn>
                </div>
            </v-col>
            <v-col md="5">
                <v-timeline class="mr-5" dense clipped>
                    <v-timeline-item fill-dot class="white--text" color="primary" icon="mdi-navigation" large>
                        <v-row justify="space-between">
                            <v-col cols="7">
                                Normal Start
                                <div class="body-2">Battery 97% | Run 245</div>
                            </v-col>
                            <v-col class="text-right" cols="5">
                                15:00 IST
                            </v-col>
                        </v-row>
                    </v-timeline-item>

                    <v-timeline-item color="primary" icon-color="grey lighten-2" small>
                        <v-row justify="space-between">
                            <v-col cols="7">
                                - -
                            </v-col>
                            <v-col class="text-right" cols="5">
                                15:26 IST
                            </v-col>
                        </v-row>
                    </v-timeline-item>

                    <v-timeline-item v-for="(trackingStatus, index) in trackingPrev" :key="`trackingPrev-${index}`"
                        :color="trackingStatus ? 'primary' : 'grey'" small>
                        <v-row justify="space-between">
                            <v-col cols="7">
                                <template v-if="trackingStatus">Normal Run</template>
                                <template v-else>.</template>
                            </v-col>
                            <v-col class="text-right" cols="5">
                                <template v-if="trackingStatus">15:25 IST </template>
                            </v-col>
                        </v-row>
                    </v-timeline-item>

                    <v-timeline-item class="mb-4" hide-dot>
                        <v-card v-if="showDetection" outlined class="pa-4 ">
                            <v-row justify="space-between">
                                <v-col cols="9">
                                    <v-chip class="white--text ml-0 mb-3" color="red" label small>
                                        <v-icon small left>mdi-alert</v-icon>
                                        DETECTION ALERT
                                    </v-chip>
                                    <v-skeleton-loader v-if="loadingTextPrediction" height="30" type="card"></v-skeleton-loader>
                                    <v-sheet v-else height="30">
                                        <div class="font-italic"> "Suspected Humans with guns approaching"</div>
                                    </v-sheet>
                                </v-col>
                                <v-col class="text-right" cols="3">
                                    15:25 IST
                                </v-col>
                                <v-col md="7">
                                    <v-img src="./../assets/detection_03.jpg">
                                        <v-icon large>mdi-play</v-icon>
                                    </v-img>
                                </v-col>
                                <v-col md="5">
                                    <p class="subtitle-2">Captured: Feb 9, 2024, 3:00 PM - 4:30 PM </p>
                                    <v-btn color="primary" outlined small @click="bottomsheetOpen = true" class="mx-0 mt-2">
                                        ANALYSE SEQUENCE
                                        <v-icon small right>mdi-creation</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-timeline-item>

                    <v-timeline-item v-for="(trackingStatus, index) in trackingNxt" :key="`trackingNxt-${index}`"
                        :color="trackingStatus ? 'primary' : 'grey'" small>
                        <v-row justify="space-between">
                            <v-col cols="7">
                                <template v-if="trackingStatus">Normal Run</template>
                                <template v-else>.</template>
                            </v-col>
                            <v-col class="text-right" cols="5">
                                <template v-if="trackingStatus">15:25 IST </template>
                            </v-col>
                        </v-row>
                    </v-timeline-item>

                    <v-timeline-item color="grey" small>
                        <v-row justify="space-between">
                            <v-col cols="7">
                                <v-chip class="white--text ml-0" color="success" label small>
                                    <v-icon small left>mdi-flash</v-icon>
                                    CHARGE STATION
                                </v-chip>
                                <!-- <div class="body-2">
                                    Charge completed in 28 mins
                                </div> -->
                            </v-col>
                            <v-col class="text-right" cols="5">

                            </v-col>
                        </v-row>
                    </v-timeline-item>

                    <v-timeline-item class="mb-4" v-for="i in 3" :key="`poleNum-${i}`" color="grey" small>
                        <v-row justify="space-between">
                            <v-col cols="7">

                            </v-col>
                            <v-col class="text-right" cols="5">

                            </v-col>
                        </v-row>
                    </v-timeline-item>

                </v-timeline>
            </v-col>
        </v-row>

        <v-bottom-sheet :overlay-opacity="0.9" v-model="bottomsheetOpen">
            <v-sheet class="px-5">
                <v-divider></v-divider>
                <DetectionViewer @close="bottomsheetOpen = false" />
            </v-sheet>
        </v-bottom-sheet>

    </v-container>
</template>

<script>
import DetectionViewer from './DetectionViewer.vue'

export default {
    data: () => ({
        events: [],
        input: null,
        nonce: 0,
        bottomsheetOpen: false,
        trackingPrev: [false, false],
        trackingNxt: [false, false, false],
        showDetection: false,
        loadingTextPrediction: true        
    }),
    computed: {
        timeline() {
            return this.events.slice().reverse();
        },
    },
    mounted() {
        var trackingPos = 0

        var simTrackingPrev = setInterval(() => {
            this.trackingPrev[trackingPos] = true
            this.$forceUpdate()
            trackingPos += 1
            if (trackingPos == 2) {
                clearInterval(simTrackingPrev)
                this.showDetectionSim()
            }
        }, 1500)

    },
    methods: {
        showDetectionSim() {
            setTimeout(() => {
                this.showDetection = true
            }, 2000)
        }
    },
    watch: {
        showDetection() {
            setTimeout(() => {
                this.loadingTextPrediction = false
            }, 2500)

            setTimeout(() => {
                this.trackingNxt[0] = true
                this.$forceUpdate()
                var trackingPos = 1
                var simTrackingNxt = setInterval(() => {
                    this.trackingNxt[trackingPos] = true
                    this.$forceUpdate()
                    trackingPos += 1
                    if (trackingPos == 3) {
                        clearInterval(simTrackingNxt)
                        this.showDetectionSim()
                    }
                }, 1500)

            }, 6700)
        }
    },
    components: { DetectionViewer }

}
</script>


<style scoped>
#myVideo {
    /* position: fixed;
      top: 0;
      left: 0; */
    width: 100%;
    height: 100%;
    object-fit: contain;
    margin-top: 20px;
}
</style>